import { LocationStrategy } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IBaseModel } from "../models/base.model";
import { BaseService } from "./base.service";
import { IAtividadeTipoTrabalhoModel } from "../models/atividade-tipo-trabalho.model";
import { FiltroModel } from "../models/filtro.model";
import { filterBy } from "../core/helpers/filterby";

@Injectable({
    providedIn: 'root',
})
export class AtividadeTipoTrabalhoService extends BaseService {
    constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
        super(httpClient, locationStrategy);
    }

    public obterTodos(filtro: FiltroModel): Promise<IBaseModel<IAtividadeTipoTrabalhoModel[]>> {
        return this.httpClient
            .get<IBaseModel<IAtividadeTipoTrabalhoModel[]>>(filterBy(filtro, `${this.apiBaseUrl}/AtividadeTipoTrabalho`))
            .toPromise();
    }

    public async obterPorId(id: number): Promise<IBaseModel<IAtividadeTipoTrabalhoModel>> {
        return this.httpClient
            .get<IBaseModel<IAtividadeTipoTrabalhoModel>>(`${this.apiBaseUrl}/AtividadeTipoTrabalho/${id}`)
            .toPromise();
    }

    public async inserir(model: IAtividadeTipoTrabalhoModel): Promise<IBaseModel<void>> {
        return this.httpClient
            .post<IBaseModel<void>>(`${this.apiBaseUrl}/AtividadeTipoTrabalho`, model)
            .toPromise();
    }

    public async atualizar(model: IAtividadeTipoTrabalhoModel): Promise<IBaseModel<void>> {
        return this.httpClient
            .put<IBaseModel<void>>(`${this.apiBaseUrl}/AtividadeTipoTrabalho/${model.id}`, model)
            .toPromise();
    }

    public async excluir(id: number): Promise<IBaseModel<void>> {
        return this.httpClient
            .delete<IBaseModel<void>>(`${this.apiBaseUrl}/AtividadeTipoTrabalho/excluir/${id}`, {})
            .toPromise();
    }


    public async ativarInativar(id: number): Promise<IBaseModel<void>> {
        return this.httpClient
            .patch<IBaseModel<void>>(`${this.apiBaseUrl}/AtividadeTipoTrabalho/ativar-ou-inativar/${id}`, {})
            .toPromise();
    }
}